<template>
  <div class='treeview position-relative'>
    <div class="treeview-search">
      <div class="treeview-item" v-show="true /*hasRole(roles.RW_OPER_DOC_ROOT_FOLDERS)*/">
        <b-form-input type="search" v-if="showSearch" v-model="findText" :placeholder="$lang.PCI.Items.TreeView.SearchPlaceholder" debounce="500" class="m-1"></b-form-input>
        <span v-else></span>
        <div v-if="foundComponents.length" class="d-flex align-items-center">
          <i class="fas fa-angle-double-left px-1" style="cursor:pointer" @click="findBefore"></i>
          <div>{{ foundPosition }}/{{ foundComponents.length }}</div>
          <i class="fas fa-angle-double-right px-1" style="cursor:pointer" @click="findNext"></i>
        </div>
        <i class="fa fa-save text-third px-1 ml-auto" style="font-size: 14px;cursor:pointer;" v-if="!sortingItem && sorting" @click="onSaveSorting"></i>
        <i class="fa fa-times text-danger px-1 ml-auto" style="font-size: 14px;cursor:pointer;" v-if="!sortingItem && sorting" @click="onCancelSorting"></i>
        <i class="fa fa-sort text-primary px-1 ml-auto" style="font-size: 14px;cursor:pointer;" v-if="showSortButton && !sortingItem && !sorting" @click="onSorting(null)"></i>
        <i class="fa fa-plus-circle text-third px-1 ml-auto" style="font-size: 14px;cursor:pointer;" v-if="showAddButton && !sortingItem && !sorting" @click="onAdd(null)"></i>
        <i class="fas fa-sync-alt text-third px-1" style="font-size: 14px;cursor:pointer;" v-if="showReloadButton && !sortingItem && !sorting" @click="$emit('reload')"></i>
      </div>
    </div>
    <ul ref="ulTreeview" class="pl-1 pt-1" v-show="!sorting">
      <item-tree-view-item v-for="(it, index) in list"
        ref="treeviewItem"
        :item="it"
        :key="it[idField]"
        :startOpen="startOpen"
        :showAddButton="showAddButton"
        :showDeleteButton="showDeleteButton"
        :showSortButton="showSortButton"
        :showCheckbox="showCheckbox"
        :checkboxField="checkboxField"
        :serializer="serializer"
        :childrenField="childrenField"
        :index="index"
        :length="list.length"
        :idField="idField"
        v-on:open="onOpen"
        v-on:selectitem="onSelectItem"
        v-on:checkitem="onCheckItem"
        v-on:add="onAdd"
        v-on:delete="onDelete"
        v-on:startSorting="onSorting"
        v-on:cancelSorting="onCancelSortingItem"
        v-on:saveSorting="onSaveSorting">
        <template #default="slotProps">
          <slot :item="slotProps.item"></slot>
        </template>
        <template #actionButtons="slotProps">
          <slot name="actionButtons" :item="slotProps.item" :index="slotProps.index" :length="slotProps.length"></slot>
        </template>
        <template #afterSerialize="slotProps">
          <slot name="afterSerialize" :item="slotProps.item"></slot>
        </template>
      </item-tree-view-item>
    </ul>
    <draggable tag="ul"
               class="list-group pl-2 pt-2"
               v-if="sorting"
               :list="list"
               ghost-class="sortable-ghost"
               @start="drag = true"
               @end="drag = false"
               :animation="100">

      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <li class="p-1 list-group-item" v-for="it in list" :key="it[idField]">{{it.order + ' - ' + serializer(it)}}</li>
      </transition-group>

    </draggable>
  </div>
</template>

<script>
import ItemTreeViewItem from './ItemTreeViewItem.vue'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'
import draggable from 'vuedraggable'
import { deburr } from 'lodash'

export default {
  name: 'ItemTreeView',
  mixins: [ PermissionMixin ],
  data () {
    return {
      roles: Roles,
      findText: '',
      sorting: false,
      sortingItem: false,
      sortingList: [],
      foundComponents: [],
      foundPosition: 0,
      drag: false
    }
  },
  props: {
    list: {type: Array, required: false},
    startOpen: {type: Boolean, required: false, default: false},
    showAddButton: {type: Boolean | Function, required: false, devault: false},
    showReloadButton: {type: Boolean, required: false, default: false},
    showDeleteButton: {type: Boolean | Function, required: false, devault: false},
    showSortButton: {type: Boolean | Function, required: false, devault: false},
    showSearch: {type: Boolean, required: false, default: true},
    showCheckbox: {type: Boolean | Function, required: false, default: false},
    checkboxField: {type: String, required: false, default: 'checked'},
    serializer: {type: Function, required: true},
    childrenField: {type: String, required: false, default: 'children'},
    idField: {type: String, required: false, default: 'id'}
  },
  components: {
    ItemTreeViewItem,
    draggable
  },
  mounted () {
    if (this.startOpen) {
      this.openAll()
    }
  },
  methods: {
    closeAll () {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          i.closeAll()
        })
      }
    },
    openAll () {
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(i => {
          i.openAll()
        })
      }
    },
    openChecked () {
      const treeviewitem = this.$refs.treeviewItem[0]
      const setOpened = (it) => {
        if (it[this.childrenField] && it[this.childrenField].length) {
          this.$set(it, 'open', treeviewitem.indeterminate(it) || treeviewitem.checked(it))
          it[this.childrenField].forEach(c => setOpened(c))
        }
      }

      this.list.forEach(it => setOpened(it))
    },
    onAdd (item) {
      this.$emit('add', item)
    },
    onOpen (item) {
      this.$emit('open', item)
    },
    onSorting (list) {
      this.sorting = list === null
      this.sortingItem = list !== null
      this.sortingList = list || this.list
      this.$refs.treeviewItem.forEach(ti => ti.onSortingItem(true))
    },
    onSaveSorting () {
      this.$emit('saveSort', this.sortingList)
    },
    confirmSaveSorting () {
      this.sorting = false
      this.sortingItem = false
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(ti => ti.confirmSaveSorting())
      }
      this.sortingList.forEach((it, idx) => {
        it.order = idx + 1
      })
      this.sortingList = []
    },
    onCancelSorting () {
      this.list.sort((a, b) => a.order - b.order)
      this.sorting = false
      this.onCancelSortingItem()
    },
    onCancelSortingItem () {
      this.sortingItem = false
      if (this.$refs.treeviewItem) {
        this.$refs.treeviewItem.forEach(ti => ti.onSortingItem(false))
      }
    },
    onSelectItem (item) {
      const _setUnselected = (_item) => {
        this.$delete(_item, 'selected')
        if (_item[this.childrenField]) {
          _item[this.childrenField].forEach(i => _setUnselected(i))
        }
      }

      this.list.forEach(i => {
        _setUnselected(i)
      })

      this.$set(item, 'selected', true)

      this.$emit('selectitem', item)
    },
    onCheckItem (item) {
      this.$emit('checkitem', item)
    },
    onChangeStatus (item) {
      this.$emit('changestatus', item)
    },
    onDelete (item) {
      this.$emit('delete', item)
    },
    setChecked (item) {
      const _setChecked = (item1, item2) => {
        const id = this.idField
        if (item1) {
          this.$set(item1, 'checked', item2 && item1[id] === item2[id])

          if (item1[this.childrenField]) {
            item1[this.childrenField].forEach(ch => {
              _setChecked(ch, item2)
            })
          }
        }
      }

      this.list.forEach(itms => { _setChecked(itms, item) })
    },
    open (item) {
      const _open = (item, id) => {
        let open = false
        if (item[this.childrenField]) {
          item[this.childrenField].forEach(_it => {
            if (_it[this.idField] === id) {
              open = true
              this.$nextTick(() => {
                this.$set(item, 'open', open)
              })
            }
            if (_it[this.childrenField]) {
              open = Boolean(open | _open(_it, id))
            }
          })
        }
        return open
      }
      this.list.forEach(_it => {
        const open = _open(_it, item[this.idField])
        this.$nextTick(() => {
          this.$set(_it, 'open', open)
        })
      })
    },
    setSelected (item) {
      this.closeAll()
      const _setSelected = (item1, item2) => {
        const id = this.idField
        if (item1) {
          if (item2 && item1[id] === item2[id]) {
            this.open(item1)
            this.$set(item1, 'selected', true)
          }

          if (item1[this.childrenField]) {
            item1[this.childrenField].forEach(ch => {
              _setSelected(ch, item2)
            })
          }
        }
      }

      this.list.forEach(itms => { _setSelected(itms, item) })
    },
    update (item) {
      const _update = (index, item1, item2) => {
        const id = this.idField
        if (item1) {
          if (item2 && item1[id] === item2[id]) {
            Object.assign(item1, item2)
            return
          }

          if (item1[this.childrenField]) {
            item1[this.childrenField].forEach((ch, idx) => { _update(idx, ch, item2) })
          }
        }
      }

      this.list.forEach((itms, index) => { _update(index, itms, item) })
    },
    getItem (id) {
      let _item = null
      const _getItem = (index, item1, _id) => {
        const id = this.idField
        if (item1) {
          if (item1[id] === _id) {
            _item = item1
          }

          if (item1[this.childrenField]) {
            item1[this.childrenField].forEach((ch, idx) => { _getItem(idx, ch, _id) })
          }
        }
      }

      this.list.forEach((itms, index) => {
        if (!_item) _getItem(index, itms, id)
      })

      return _item
    },
    findAll (searchText, find = true) {
      const normSearch = deburr(searchText).toLowerCase()

      const _haveChildFound = item => {
        let count = 0
        const _countFound = _it => {
          if (_it.found) {
            count++
          }
          if (_it[this.childrenField]) {
            _it[this.childrenField].forEach(__it => _countFound(__it))
          }
        }
        if (item[this.childrenField]) {
          item[this.childrenField].forEach(__it => _countFound(__it))
        }
        return count > 0
      }

      const _findAll = item => {
        const normText = deburr(this.serializer(item)).toLowerCase()
        this.$set(item, 'found', searchText && normText.includes(normSearch))
        if (item[this.childrenField]) {
          item[this.childrenField].forEach(it => {
            _findAll(it)
            this.$set(it, 'open', _haveChildFound(it))
          })
        }
      }

      this.foundPosition = 1
      this.foundComponents = []

      this.list.forEach(it => {
        _findAll(it)
        this.$set(it, 'open', _haveChildFound(it))
      })

      if (find) {
        this.$nextTick(() => {
          const _findNext = (comp) => {
            const normComp = deburr(this.serializer(comp.item)).toLowerCase()
            if (normComp.includes(normSearch)) {
              this.foundComponents.push(comp)
            }
            if (comp.$refs.treeviewItem) {
              comp.$refs.treeviewItem.forEach(i => _findNext(i))
            }
          }

          this.$refs.treeviewItem.forEach(c => _findNext(c))

          this.$nextTick(() => {
            if (this.foundComponents.length) {
              const el = this.foundComponents[0].$el.querySelector('div.treeview-item-folder')
              this.$refs.ulTreeview.scrollTo({top: el.offsetTop - 60, behavior: 'smooth'})
              this.$emit('scrollTo', el.offsetTop)
            }
          })
        })
      }
    },
    findNext () {
      if (this.foundPosition === this.foundComponents.length) {
        this.foundPosition = 1
      } else {
        this.foundPosition = this.foundPosition + 1
      }

      const el = this.foundComponents[this.foundPosition - 1].$el.querySelector('div.treeview-item-folder')
      this.$refs.ulTreeview.scrollTo({top: el.offsetTop - 60, behavior: 'smooth'})
      this.$emit('scrollTo', el.offsetTop)
    },
    findBefore () {
      if (this.foundPosition === 1) {
        this.foundPosition = this.foundComponents.length
      } else {
        this.foundPosition = this.foundPosition - 1
      }

      const el = this.foundComponents[this.foundPosition - 1].$el.querySelector('div.treeview-item-folder')
      this.$refs.ulTreeview.scrollTo({top: el.offsetTop - 60, behavior: 'smooth'})
      this.$emit('scrollTo', el.offsetTop)
    },
    stopFind () {
      this.findAll(null, false)
      this.foundComponents = []
      this.foundPosition = 0
    }
  },
  watch: {
    findText: function (val) {
      if (val && val.length > 2) {
        this.findAll(val)
      } else {
        this.stopFind()
      }
    }
  }
}
</script>

<style scoped>
.treeview {
  padding: 0px;
  background-color: #fff;
  width: 100%;
  height: 100%;
}

.treeview >>> treeview-item i,
a {
  font-size: 12px;
}

.treeview ul {
  height: calc(100% - 55px);
  overflow-y: auto;
  overflow-x: hidden;
}

.treeview >>> .treeview-item {
  padding-top: 6px;
  padding-bottom: 2px;
  padding-right: 5px;
  padding-left: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.treeview >>> .treeview-item::not(.treeview-item-selected) {
  border-bottom: solid 1px #f5f5f5;
}

.treeview >>> .treeview-item-icon {
  padding-right: 6px;
  font-size: 10px;
}

::-webkit-scrollbar-track {
  border-radius: 12px !important;
  background: #fcfcfc !important;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background: #c2c2c2 !important;
}

::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
}

::-webkit-scrollbar-thumb:hover {
  border-radius: 10px !important;
  background: #a1a1a1 !important;
}

.treeview-search {
  position: sticky;
  top: 0;
}

.list-group {
  overflow-y: auto;
  height: calc(100% - 55px);
}
.list-group-item {
  cursor: grab;
}
.sortable-ghost {
  opacity: 0.5;
  background: #c8fbd6;
}
.flip-list-move {
  transition: transform 0.2s;
}
.no-move {
  transition: transform 0s;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/treeview/ItemTreeView.vue